<!--
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors: zhangzhitao
 * @LastEditTime: 2019-12-10 13:43:29
 * @Description:
 -->
/*
* @Author: zhangzhitao
* @Date: 2019-06-20 12:16:14
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-07-11 22:17:48
*/

<template>
  <el-submenu
    v-if="!menu.fullUrl&&menu.children&&menu.children.length>0"
    :index="menu.menuId||''"
    :name="`cover_${menu.menuId}`"
  >
    <template v-slot:title>
      <span :title="menu.name">{{ menu.name }}</span>
    </template>
    <menu-item
      v-for="(sub) in menu.children"
      :key="sub.id"
      :menu="sub"
    ></menu-item>
  </el-submenu>
  <el-menu-item
    v-else
    :title="menu.name"
    :index="menu.menuId||''"
  >
    {{menu.name}}</el-menu-item>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    menu: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="less" scoped>
.m-linkage-nav-outer {
  /deep/ .el-submenu__title {
    .el-submenu__title--text {
      display: inline-block;
      width: calc(~"100% - 32px");
      top: -3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
